import { render, staticRenderFns } from "./LessonSlideViewerComponent.vue?vue&type=template&id=68bbf7d6&scoped=true&"
import script from "./LessonSlideViewerComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSlideViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSlideViewerComponent.vue?vue&type=style&index=0&id=68bbf7d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bbf7d6",
  null
  
)

export default component.exports